<template>
  <div class="container previewOrderContainer" v-if="!submittingGiftCard">
    <div class="row">
      <div class="col-12 col-lg-3" v-if="componentSetUp">
        <div class="checkout-form-block">
          <div class="row">
            <div class="col-12">
              <Lottie
                ref="lottie"
                :animation-data="giftCardLottie"
                :auto-play="true"
                :loop="false"
                width="250px"
                height="250px"
              />
              <div class="gift-cards-total">
                <span class="gift-cards-total-title" v-html="`${applyCurrency(order.selectedGiftCard)}${currency.symbol}`"></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-5" v-if="componentSetUp">
        <div class="checkout-form-block">
          <div class="row">
            <div class="col-12 checkout-form-header">
              <span class="checkout-form-title">{{ t('giftCard.label.title', { namespace: 'giftCards' }) }}</span>
            </div>

            <div class="col-12 gift-cards-content text-center">
              <div class="btn-group-gift-cards btn-group-toggle">
                <label
                  class="btn focus"
                  v-for="giftCardOption in displayedGiftCards"
                  :class="order.selectedGiftCard === giftCardOption ? 'active' : ''"
                  :key="giftCardOption">
                  <input
                    type="radio"
                    :value="giftCardOption"
                    v-model="order.selectedGiftCard"
                    @change="onGiftCardChange"
                  >
                  <span v-html="`${applyCurrency(giftCardOption)}${currency.symbol}`"></span>
                </label>
                <button v-if="remainingGiftCards > 0" @click="toggleGiftCardsDisplay" class="btn btn-gift-cards-toggle">
                  {{ order.showAllGiftCards ? '-' : '+' }}{{ remainingGiftCards }}
                </button>
                <label class="btn focus free-amount-label" v-show="settings.freeAmount">
                  <input
                    type="number"
                    v-model="order.giftCardFreeAmount"
                    :min="settings.minAmount"
                    :max="settings.maxAmount"
                    step="0.01"
                    class="form-control"
                    :placeholder="t('giftCard.label.freeAmount', { namespace: 'giftCards' })"
                  >
                </label>
              </div>
            </div>

            <div class="col-12 checkout-form-header">
              <span class="checkout-form-title">{{ t('giftCard.label.sendGiftCardTo', { namespace: 'giftCards' }) }}</span>
            </div>

            <div class="col-12 gift-cards-contact-type">

              <div class="col-12 gift-cards-contact-radio-buttons">
                <div v-show="settings.enabledSms" class="form-check">
                  <input type="radio" id="contactEmail" class="form-check-input" value="email" v-model="order.giftCardContactType">
                  <label class="form-check-label" for="contactEmail">{{ t('giftCard.label.sendToEmail', { namespace: 'giftCards' }) }}</label>
                </div>
                <div v-if="settings.enabledSms" class="form-check">
                  <input type="radio" id="contactMobile" class="form-check-input" value="mobile" v-model="order.giftCardContactType">
                  <label class="form-check-label" for="contactMobile">{{ t('giftCard.label.sendToMobile', { namespace: 'giftCards' }) }}</label>
                </div>
                <div v-if="settings.enabledSms" class="form-check">
                  <input type="radio" id="contactBoth" class="form-check-input" value="both" v-model="order.giftCardContactType">
                  <label class="form-check-label" for="contactBoth">{{ t('giftCard.label.sendToBoth', { namespace: 'giftCards' }) }}</label>
                </div>
              </div>

              <div class="col-12 gift-cards-contact-inputs">
                <div v-if="order.giftCardContactType === 'email' || order.giftCardContactType === 'both'">
                  <label for="sendToEmail">Email:</label>
                  <input type="email" id="sendToEmail" class="form-control" v-model="order.sendToEmail" :placeholder="t('giftCard.label.sendToEmailPlaceholder', { namespace: 'giftCards' })">
                  <check-out-form-error :error="errors.sendToEmail || ''"></check-out-form-error>
                </div>
                <div v-if="(order.giftCardContactType === 'mobile' || order.giftCardContactType === 'both') && settings.enabledSms">
                  <label for="sendToPhone">{{ t('giftCard.label.sendToMobile', { namespace: 'giftCards' }) }}:</label>
                  <input type="tel" id="sendToPhone" class="form-control" v-model="order.sendToPhone" :placeholder="t('giftCard.label.sendToMobilePlaceholder', { namespace: 'giftCards' })">
                  <check-out-form-error :error="errors.sendToPhone || ''"></check-out-form-error>
                </div>
                <div v-if="showSendToData" class="gift-cards-contact-inputs-data">
                  <div>
                    <label for="sendToName">{{ t('giftCard.label.sendToNamePlaceholder', { namespace: 'giftCards' }) }}:</label>
                    <input type="text" id="sendToName" class="form-control" v-model="order.sendToName" :placeholder="t('giftCard.label.sendToNamePlaceholder', { namespace: 'giftCards' })">
                    <check-out-form-error :error="errors.sendToName || ''"></check-out-form-error>
                  </div>
                  <div>
                    <label for="sendToSurname">{{ t('giftCard.label.sendToSurnamePlaceholder', { namespace: 'giftCards' }) }}:</label>
                    <input type="email" id="sendToSurname" class="form-control" v-model="order.sendToSurname" :placeholder="t('giftCard.label.sendToSurnamePlaceholder', { namespace: 'giftCards' })">
                    <check-out-form-error :error="errors.sendToSurname || ''"></check-out-form-error>
                  </div>
                </div>

                <div v-if="showSendToData" class="gift-card-col-center-content-message">
                  <div class="checkout-form-header">
                    <span class="checkout-form-title">
                      {{ t('giftCard.label.send_to_customer.title', { namespace: 'giftCards' }) }}
                    </span>
                  </div>
                  <div class="gift-cards-contact-message">
                    <textarea id="message" class="form-control" rows="5" placeholder="Το μήνυμά σου" v-model="order.message"></textarea>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>

      <div class="col-12 col-lg-4">
        <div class="checkout-form-block">
          <div class="row">
            <div class="col-12 checkout-form-header">
              <span class="checkout-form-title">{{ t('giftCard.label.billingInformation', { namespace: 'giftCards' }) }}</span>
            </div>
            <div class="col-12 col-md-6 checkout-form-col">
              <label for="name">{{ t('customer.name') }}:</label>
              <input type="text" id="name" class="form-control"
                     v-model="customerData.name"
                     :placeholder="t('customer.name')" required>
              <check-out-form-error :error="errors.name || ''"></check-out-form-error>
            </div>
            <div class="col-12 col-md-6 checkout-form-col">
              <label for="surname">{{ t('customer.surname') }}:</label>
              <input type="text" id="surname" class="form-control"
                     v-model="customerData.surname"
                     :placeholder="t('customer.surname')" required>
              <check-out-form-error :error="errors.surname || ''"></check-out-form-error>
            </div>
            <div class="col-12 checkout-form-col">
              <label for="landphone">{{ t('customer.phone') }}:</label>
              <input type="text" id="landphone" class="form-control"
                     v-model="customerData.landphone"
                     :placeholder="t('customer.phone')"
                     @input="sanitizePhoneNumber" required>
              <check-out-form-error :error="errors.landphone || ''"></check-out-form-error>
            </div>

            <div v-show="!isCustomerLoggedIn" class="col-12 form-group  checkout-form-col">
              <label for="mail">{{ t('customer.email') }}:</label>
              <input
                type="email"
                id="mail"
                class="form-control"
                v-model="customerData.mail"
                :placeholder="t('customer.email')"
                :required="!isCustomerLoggedIn"
              >
              <check-out-form-error :error="errors.mail || ''"></check-out-form-error>
            </div>
          </div>

          <div v-show="!isCustomerLoggedIn" class="row">
            <div v-show="customerData.is_guest === '0'" class="col-12 checkout-form-col passwordInputField">
              <label for="password">{{ t('customer.password') }}:</label>
              <input
                type="password"
                id="password"
                class="form-control"
                v-model="password"
                :placeholder="t('customer.password')"
                :required="passwordRequired"
              >
              <check-out-form-error :error="errors.password || ''"></check-out-form-error>
            </div>
            <div v-show="customerData.is_guest === '0'" class="col-12 checkout-form-col passwordInputField">
              <label for="password_retype">{{ t('customer.password.repeat') }}:</label>
              <input
                type="password"
                id="password_retype"
                class="form-control"
                v-model="passwordVerify"
                :placeholder="t('customer.password.repeat')"
                :required="passwordRequired"
              >
              <check-out-form-error :error="passwordRetype || ''"></check-out-form-error>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-md-8 checkout-form-col">
              <label for="city">{{ t('customer.city') }}:</label>
              <input type="text" id="city" class="form-control"
                     v-model="customerData.city"
                     :placeholder="t('customer.city')" required>
              <check-out-form-error :error="errors.city || ''"></check-out-form-error>
            </div>
            <div class="col-12 col-md-4 checkout-form-col">
              <label for="postal">{{ t('customer.postal.index') }}:</label>
              <input type="text" id="postal" class="form-control"
                     v-model="customerData.postal" :placeholder="t('customer.postal.index')" required>
              <check-out-form-error :error="errors.postal || ''"></check-out-form-error>
            </div>
            <div class="col-12 checkout-form-col">
              <label for="address">{{ t('customer.address') }}:</label>
              <input type="text" id="address" class="form-control"
                     v-model="customerData.address" :placeholder="t('customer.address')" required>
              <check-out-form-error :error="errors.address || ''"></check-out-form-error>
            </div>
            <div class="col-12 col-md-6 checkout-form-col">
              <label for="country">{{ t('customer.country') }}:</label>
              <select
                id="country"
                class="form-control dropdown_custom_field"
                v-model="customerData.country"
                required
              >
                <option v-for="(countryValue, countryKey, index) in countryAndCountyData.country"
                        :key="index" :value="countryKey">{{ countryValue }}</option>
              </select>
              <check-out-form-error :error="errors.country || ''"></check-out-form-error>
            </div>
            <div class="col-12 col-md-6 checkout-form-col">
              <label for="county">{{ t('customer.area') }}:</label>
              <select
                id="county"
                class="form-control dropdown_custom_field"
                v-model="customerData.county"
                required
              >
                <option disabled value="">{{ t('selectCounty') }}</option>
                <option v-for="(countiesValue, countyKey, index) in availableCounties"
                        :key="index" :value="countyKey">{{ countiesValue }}</option>
              </select>
              <check-out-form-error :error="errors.county || ''"></check-out-form-error>
            </div>
          </div>
        </div>
        <div class="checkout-form-block">
          <div class="row">
            <div class="col-12 checkout-form-header">
              <span class="checkout-form-title">{{ t('preview.order.payment.method') }}</span>
            </div>

            <template v-for="payWay in validPayWays">
              <div class="custom-control custom-radio" :key="payWay.key">
                <input type="radio"
                       :value="payWay.key"
                       :id="payWay.key"
                       class="custom-control-input"
                       v-model="order.payWay"
                >
                <label class="custom-control-label" :for="payWay.key">
                  {{ t(payWay.localeKey) }}
                </label>

                <div v-if="payWay.key === 'apcopay' && hasApcopayInstallments" :key="`apco${payWay.key}`"
                     class="col-12 checkout-form-col" v-show="order.payWay === 'apcopay'">
                  <label for="apco-form-installments" class="orderFldLbl">
                    {{ t('eshop.front.checkout.installments') }}
                  </label>
                  <select name="installments" id="apco-form-installments" class="form-control" v-model="order.apcoInstallments">
                    <option v-for="(installmentLabel, installmentKey) in payWayInstallments.apco"
                            :key="`apco${installmentKey}`" :value="installmentKey">{{ installmentLabel }}</option>
                  </select>
                </div>

                <div v-if="payWay.key === 'piraeus' && hasPiraeusInstallments" :key="`piraeus${payWay.key}`"
                     class="col-12 checkout-form-col" v-show="order.payWay === 'piraeus'">
                  <label for="piraeus-form-installments" class="orderFldLbl">
                    {{ t('eshop.front.checkout.installments') }}
                  </label>
                  <select name="installments" id="piraeus-form-installments" class="form-control" v-model="order.piraeusInstallments">
                    <option v-for="(installmentLabel, installmentKey) in payWayInstallments.piraeus.installments"
                            :key="`piraeus${installmentKey}`" :value="installmentKey">{{ installmentLabel }}</option>
                  </select>
                </div>

                <div v-if="payWay.key === 'eurobank' && hasEurobankInstallments" :key="`eurobank${payWay.key}`"
                     class="col-12 checkout-form-col" v-show="order.payWay === 'eurobank'">
                  <label for="eurobank-form-installments" class="orderFldLbl">
                    {{ t('eshop.front.checkout.installments') }}
                  </label>
                  <select name="installments" id="eurobank-form-installments" class="form-control" v-model="order.eurobankInstallments">
                    <option v-for="(installmentLabel, installmentKey) in payWayInstallments.eurobank.installments"
                            :key="`eurobank${installmentKey}`" :value="installmentKey">{{ installmentLabel }}</option>
                  </select>
                </div>
              </div>
            </template>

            <check-out-form-error :error="errors.payway"></check-out-form-error>
          </div>
        </div>

        <div id="customerFormSubmit" class="checkout-form-block">
          <div class="checkbox termsAgree">
            <input
              id="termsAcceptCheck"
              type="checkbox"
              class="checkbox_input"
              required
              v-model="termsChecked">
            <label for="termsAcceptCheck" class="checkbox_label">
              {{ t('customer.register.terms.agree') }}
              <a target="_blank" :href="t('customer.register.terms.link.href')">
                {{ t('customer.register.terms.link') }}
              </a>
            </label>
          </div>
          <button
            class="submit-btn" value="true"
            :disabled="!validData" :class="validData ? '' : 'disabled'"
            v-on:click="submitOrder"
          >
            {{ t('preview.order.continue') }}
          </button>
        </div>
      </div>
    </div>
    <div v-if="hasPaymentResult && getPaymentResult.type === 'NbgIframe'">
      <NbgIframe
        :data="getPaymentResult.data"></NbgIframe>
    </div>
    <div v-if="hasPaymentResult && getPaymentResult.type === 'PaypalAdvanced'">
      <GenericModal
        unique-id="paypal-advanced-modal"
        :should-modal-start-in-open-state="true"
        :max-height="'none'"
        :overflow="'auto'"
      >
          <h2>Paypal Advanced Checkout</h2>
          <PaypalAdvanced :data="getPaymentResult.data" />
      </GenericModal>
    </div>
    <div v-if="hasPaymentResult && getPaymentResult.type === 'NbgEEIframe'">
      <NbgEEIFrame :data="getPaymentResult.data"></NbgEEIFrame>
    </div>
  </div>

  <div v-else class="container previewOrderContainer">
    <slot name="wait">
      <div class="row">
        <div class="col-12">
          <div class="checkout-form-block">
            <div class="row">
              <div class="col-12 checkout-form-header">
                <span class="checkout-form-title text-center">{{ t('giftCard.label.pleaseWait', { namespace: 'giftCards' }) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="hasPaymentResult && getPaymentResult.type === 'redirect'">
        <form :action="getPaymentResult.url" method="post" accept-charset="utf-8" ref="payway-form">
          <div v-for="(value, name) in getPaymentResult.data" :key="name">
            <input type="hidden" :name="name" :value="value">
          </div>
        </form>
      </div>
    </slot>
  </div>
</template>

<script>
import CheckOutFormError from '../CheckOutFormError.vue'
import { phoneNumberSanitizer } from '../../js/es6/utilities/sanitizers'
import { mapGetters, mapActions } from 'vuex'
import giftCardLottieFile from '../../lotties/gift_card.json'
import Lottie from '../Lottie.vue'
import NbgIframe from './Widgets/NbgIframe.vue'
const NbgEEIFrame = () => import(/* webpackChunkName: "NbgEEIFrame" */ './Widgets/NbgEEIframe.vue')
import PaypalAdvanced from './Widgets/PaypalAdvanced.vue'
import GenericModal from '../presentation/GenericModal.vue'

export default {
  name: 'GiftCardPage',
  components: { GenericModal, NbgIframe, NbgEEIFrame, CheckOutFormError, Lottie, PaypalAdvanced },
  data () {
    return {
      password: '',
      passwordVerify: '',
      order: {
        selectedGiftCard: 20,
        maxGiftCardDisplay: 9,
        giftCardFreeAmount: null,
        showAllGiftCards: false,
        giftCardContactType: 'email',
        payWay: '',
        sendToEmail: '',
        sendToName: '',
        sendToSurname: '',
        message: '',
        sendToPhone: '',
        apcoInstallments: null,
        eurobankInstallments: null,
        piraeusInstallments: null
      },
      termsChecked: false,
      showSendToData: false
    }
  },
  computed: {
    ...mapGetters({
      submittingGiftCard: 'giftCards/isSubmittingGiftCard',
      settings: 'giftCards/getSettings',
      validPayWays: 'giftCards/getPayWays',
      customerData: 'giftCards/getCustomerData',
      errors: 'giftCards/getErrors',
      applyCurrency: 'getPriceUsingCurrency',
      currency: 'getSelectedCurrency',
      isCustomerLoggedIn: 'isCustomerLoggedIn',
      countryAndCountyData: 'giftCards/getCountryAndCountyData',
      payWayInstallments: 'giftCards/getPayWayInstallments',
      hasApcopayInstallments: 'giftCards/hasApcopayInstallments',
      hasPiraeusInstallments: 'giftCards/hasPiraeusInstallments',
      hasEurobankInstallments: 'giftCards/hasEurobankInstallments',
      getPaymentResult: 'giftCards/getPaymentResult',
      hasPaymentResult: 'giftCards/hasPaymentResult',
      componentSetUp: 'giftCards/initialDataSetUp'
    }),
    availableCounties () {
      if (this.customerData.country === '') {
        return {}
      }
      return this.countryAndCountyData.county[this.customerData.country] || {}
    },
    validData () {
      if (
        !this.termsChecked ||
        !this.customerData.name ||
        !this.customerData.surname ||
        !this.customerData.city ||
        !this.customerData.postal ||
        !this.customerData.country ||
        !this.customerData.county ||
        !this.customerData.address ||
        !this.customerData.landphone ||
        !this.order.payWay ||
        !this.order.selectedGiftCard
      ) {
        return false
      }

      if (!(this.order.sendToPhone || this.order.sendToEmail)) {
        return false
      }

      if (this.customerData.is_guest === '0' && !this.customerData.mail) {
        return false
      }

      return true
    },
    passwordRetype () {
      return this.password === this.passwordVerify ? '' : this.t('password-retype-error')
    },
    installments () {
      if (this.order.payWay === 'apcopay' && this.order.apcoInstallments) {
        return this.order.apcoInstallments
      }
      if (this.order.payWay === 'piraeus' && this.order.piraeusInstallments) {
        return this.order.piraeusInstallments
      }
      if (this.order.payWay === 'eurobank' && this.order.eurobankInstallments) {
        return this.order.eurobankInstallments
      }
      return null
    },
    displayedGiftCards () {
      const prices = this.order.showAllGiftCards ? this.settings.giftCards : this.settings.giftCards.slice(0, this.order.maxGiftCardDisplay)
      return prices.map(price => Number(price))
    },
    giftCardLottie () {
      return giftCardLottieFile
    },
    remainingGiftCards () {
      return Math.max(0, this.settings.giftCards.length - this.order.maxGiftCardDisplay)
    }
  },
  watch: {
    hasPaymentResult: function (val) {
      if (val) {
        this.$nextTick(() => {
          this.processPayment()
        })
      }
    },
    'order.giftCardFreeAmount': function (newValue) {
      this.order.selectedGiftCard = newValue
    }
  },
  methods: {
    ...mapActions({
      buyGiftCard: 'giftCards/buyGiftCard'
    }),
    sanitizePhoneNumber () {
      this.customerData.landphone = phoneNumberSanitizer(this.customerData.landphone)
      this.customerData.mobilephone = phoneNumberSanitizer(this.customerData.mobilephone)
    },
    passwordRequired () {
      if (this.isCustomerLoggedIn) {
        return false
      }
      return this.customerData.is_guest !== '1'
    },
    submitOrder () {
      const formData = {
        customer_id: this.customerData.id,
        is_guest: this.customerData.is_guest,
        mail: this.customerData.mail,
        password: this.password,
        name: this.customerData.name,
        surname: this.customerData.surname,
        landphone: this.customerData.landphone,
        mobilephone: this.customerData.mobilephone,
        address: this.customerData.address,
        city: this.customerData.city,
        region: this.customerData.region,
        county: this.customerData.county,
        country: this.customerData.country,
        postal: this.customerData.postal,
        giftCard: this.order.selectedGiftCard,
        payway: this.order.payWay,
        installments: this.installments,
        sendToEmail: this.order.sendToEmail,
        sendToPhone: this.order.sendToPhone,
        sendToName: this.order.sendToName,
        sendToSurname: this.order.sendToSurname,
        message: this.order.message
      }

      this.buyGiftCard(formData)
    },
    processPayment () {
      if (!this.hasPaymentResult) {
        return
      }
      switch (this.getPaymentResult.type) {
        case 'redirect':
          this.$refs['payway-form'].submit()
          break
        case 'refresh':
          window.location.href = this.getPaymentResult.url
          break
        case 'NbgIframe':
          window.scrollTo(0, 0)
          break
        case 'NbgEEIframe':
          window.scrollTo(0, 0)
          break
        case 'PaypalAdvanced':
          window.scrollTo(0, 0)
          break
      }
    },
    toggleGiftCardsDisplay () {
      this.order.showAllGiftCards = !this.order.showAllGiftCards
    },
    onGiftCardChange () {
      const lottieComponent = this.$refs.lottie
      lottieComponent.goToAndPlay(0, true)
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-group-gift-cards {
  position: relative;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 10px;
  .btn {
    margin: 0;
    padding: 10px;
    display: grid;
    justify-items: center;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: 1px solid #dadada;
    &.active {
      background: #477DC0;
      color: #fff;
      border-color: #477DC0;
      span {
        color: #fff;
      }
    }
    span {
      color: #000;
      font-weight: 700;
    }
  }
  .free-amount-label {
    grid-column: span 2;
    display: flex;
    padding: 0;
    border: unset;
  }
}
.btn-gift-cards-toggle {
  color: #477DC0;
}
.gift-cards-total {
  display: grid;
  justify-items: center;
  align-items: center;
  &-title {
    font-weight: 700;
    font-size: 2rem;
  }
}
.checkout-form-col {
  padding: 0 5px;

  label {
    display: none
  }
}
.dropdown_custom_field {
  color: #000000;
}
#customerFormSubmit {
  display: grid;
  align-items: center;
  justify-items: end;
}
.checkout-form-block {
  border-bottom: none;
}
.gift-cards-content {
  padding: 0;
  margin-bottom: 30px;
}
.checkout-form-title {
  font-size: 24px;
  font-weight: 700;
}
.gift-cards-contact-type {
  padding: 0;
}
.gift-cards-contact-radio-buttons {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0 0 1rem;
  .form-check-input {
    margin-top: 0.45rem;
  }
}
.gift-cards-contact-inputs {
  display: grid;
  gap: 1rem;
  padding: 0;
  label {
    display: none;
  }
}
.gift-cards-contact-inputs-data {
  display: grid;
  gap: 1rem;
  grid-template-columns: 1fr 1fr;
}
.form-control {
  font-size: 0.9rem
}

::v-deep .cp-utilities-generic_modal-overlay-close {
  width: unset;
}
</style>
